import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-paper px-6">
      <div className="text-center">
        <div className="font-display text-6xl text-foreground">404</div>
        <p className="text-muted-foreground mt-2">That page doesn't exist in Kandake Prime.</p>
        <Link to="/dashboard"><Button className="mt-4" style={{background:"hsl(347 72% 22%)"}}>Back to dashboard</Button></Link>
      </div>
    </div>
  );
}
